/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { VoiceDictationState } from '@atlassian/ai-audio';
import { EllipsesAnimation } from '@atlassian/conversation-assistant-ui-components/ui/EllipsesAnimation';

const styles = cssMap({
	ellipsesContainer: {
		flex: 1,
	},
});

type VoiceRecordingPanelProps = {
	children: ReactNode;
	state: VoiceDictationState;
};

export const VoiceRecordingPanel = ({ children, state }: VoiceRecordingPanelProps): string | number | boolean | Iterable<ReactNode> | JSX.Element | null | undefined => {
	switch (state) {
		case VoiceDictationState.Recording:
		case VoiceDictationState.Initializing:
			return (
				<Box xcss={styles.ellipsesContainer}>
					<EllipsesAnimation isAnimated={true} />
				</Box>
			);
		default:
			return children;
	}
};
